import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

class NightingaleB2BProforma extends Component {
  #abortController = new AbortController();

  connectedCallback() {
    super.connectedCallback();

    const { signal } = this.#abortController;
    const section = this.closest('.shopify-section, dialog');

    this.querySelector('[data-nightingale-b2b-open]')?.addEventListener('click', this.openDialog, { signal });
    this.querySelector('[data-nightingale-b2b-close]')?.addEventListener('click', this.closeDialog, { signal });
    this.dialog?.addEventListener('click', this.handleDialogClick, { signal });
    section?.addEventListener(ThemeEvents.variantUpdate, this.handleVariantUpdate, { signal });
    section?.addEventListener('input', this.handleQuantityChange, { signal });
    section?.addEventListener('change', this.handleQuantityChange, { signal });

    this.refreshRuntimeContext();
    this.syncQuantity();

    if (this.querySelector('.nightingale-b2b-proforma__message')) {
      this.openDialog();

      if (this.querySelector('[data-nightingale-b2b-success]')) {
        document.dispatchEvent(new CustomEvent('nightingale_b2b_proforma_submit', { bubbles: true }));
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#abortController.abort();
  }

  get dialog() {
    return this.querySelector('[data-nightingale-b2b-dialog]');
  }

  openDialog = () => {
    if (!(this.dialog instanceof HTMLDialogElement) || this.dialog.open) return;

    this.syncQuantity();
    this.refreshRuntimeContext();
    this.dialog.showModal();
    document.dispatchEvent(new CustomEvent('nightingale_b2b_proforma_open', { bubbles: true }));
  };

  closeDialog = () => {
    if (this.dialog instanceof HTMLDialogElement && this.dialog.open) {
      this.dialog.close();
    }
  };

  handleDialogClick = (event) => {
    if (event.target === this.dialog) {
      this.closeDialog();
    }
  };

  handleQuantityChange = (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.name !== 'quantity') return;

    this.syncQuantity();
  };

  handleVariantUpdate = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.detail.data.productId !== this.dataset.productId) {
      return;
    }

    const updatedComponent = event.detail.data.html.querySelector('nightingale-b2b-proforma');
    if (!(updatedComponent instanceof HTMLElement)) return;

    for (const field of this.querySelectorAll('[data-nightingale-b2b-context]')) {
      if (!(field instanceof HTMLInputElement)) continue;

      const selector = `[data-nightingale-b2b-context="${field.dataset.nightingaleB2bContext}"]`;
      const updatedField = updatedComponent.querySelector(selector);

      if (updatedField instanceof HTMLInputElement) {
        field.value = updatedField.value;
      }
    }

    const quantityField = this.querySelector('[data-nightingale-b2b-quantity]');
    const updatedQuantityField = updatedComponent.querySelector('[data-nightingale-b2b-quantity]');

    if (quantityField instanceof HTMLInputElement && updatedQuantityField instanceof HTMLInputElement) {
      for (const attribute of ['min', 'max', 'step']) {
        if (updatedQuantityField.hasAttribute(attribute)) {
          quantityField.setAttribute(attribute, updatedQuantityField.getAttribute(attribute) || '');
        } else {
          quantityField.removeAttribute(attribute);
        }
      }
    }

    this.syncQuantity();
    requestAnimationFrame(() => this.refreshRuntimeContext());
  };

  syncQuantity = () => {
    const productQuantity = this.closest('.shopify-section, dialog')?.querySelector(
      'product-form-component input[name="quantity"]'
    );
    const requestQuantity = this.querySelector('[data-nightingale-b2b-quantity]');

    if (productQuantity instanceof HTMLInputElement && requestQuantity instanceof HTMLInputElement) {
      requestQuantity.value = productQuantity.value;
    }
  };

  refreshRuntimeContext = () => {
    const sourceUrl = this.querySelector('[data-nightingale-b2b-context="source-url"]');
    const productUrl = this.querySelector('[data-nightingale-b2b-context="product-url"]');

    if (sourceUrl instanceof HTMLInputElement) {
      sourceUrl.value = window.location.href;
    }

    if (productUrl instanceof HTMLInputElement) {
      productUrl.value = `${window.location.origin}${window.location.pathname}${window.location.search}`;
    }
  };
}

if (!customElements.get('nightingale-b2b-proforma')) {
  customElements.define('nightingale-b2b-proforma', NightingaleB2BProforma);
}
